/**
 * Recursively converts all null values to undefined in an object
 * This is useful for database adapters where databases can return null values
 * but the common format expects undefined for optional fields
 */
export function convertNullToUndefined<T>(obj: T): T {
  if (obj === null) {
    return undefined as T;
  }

  if (obj === undefined) {
    return obj;
  }

  // Special case for Date objects - preserve them as-is
  if (obj instanceof Date) {
    return obj;
  }

  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return obj.map(convertNullToUndefined) as T;
    }

    const result = {} as T;
    for (const [key, value] of Object.entries(obj)) {
      (result as any)[key] = convertNullToUndefined(value);
    }
    return result;
  }

  return obj;
}
